"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameModeTransitionManager = void 0;
const GameModuleConfig_1 = require("../../../core/gamemoduleconfig/GameModuleConfig");
const EventHandler_1 = require("../../../core/event/EventHandler");
const GameModeEvent_1 = require("../../../core/gamemode/event/GameModeEvent");
const SlotGame_1 = require("../../../core/SlotGame");
class GameModeTransitionManager {
    constructor() {
        this._transitions = [];
        const factoryMethods = GameModuleConfig_1.GameModuleConfig.instance.GAME_MODE_TRANSITIONS;
        if (factoryMethods) {
            for (let i = 0; i < factoryMethods.length; i++) {
                const transition = factoryMethods[i]();
                if (this.checkIfDuplicate(transition)) {
                    SlotGame_1.SlotGame.api.warn(`GameModeTransition for states, [from: ${transition._fromMode}], [to: ${transition._toMode}] already exist.`);
                }
                transition.onFinishCallback = (transition) => GameModeTransitionManager.onCompleteCallback(transition);
                this._transitions.push(transition);
            }
        }
    }
    checkIfDuplicate(newTransition) {
        for (let transition of this._transitions) {
            if (transition._fromMode == newTransition._fromMode && transition._toMode == newTransition._toMode) {
                return true;
            }
        }
        return false;
    }
    tryToMakeTransition() {
        for (let i = 0; i < this._transitions.length; i++) {
            const transition = this._transitions[i];
            if (transition.isTriggered) {
                transition.start();
                EventHandler_1.EventHandler.dispatchEvent((new GameModeEvent_1.GameModeEvent(GameModeEvent_1.GameModeEvent.GAME_MODE_TRANSITION_STARTED, transition._fromMode, transition._toMode)));
                return true;
            }
        }
        return false;
    }
    static onCompleteCallback(transition) {
        EventHandler_1.EventHandler.dispatchEvent((new GameModeEvent_1.GameModeEvent(GameModeEvent_1.GameModeEvent.GAME_MODE_TRANSITION_FINISHED, transition._fromMode, transition._toMode)));
    }
}
exports.GameModeTransitionManager = GameModeTransitionManager;
//# sourceMappingURL=GameModeTransitionManager.js.map